import api from "../../adapter/base"
import {useInfiniteQuery} from "react-query";
const fetchProducts = async (page=1,name,paginate=12) => {
    const res=await api.get(`/products?name=${name}&page=${page}&paginate=${paginate}`);
    return res.data.data;
}

export const useProducts = ({page, name}) => {
    const { data, isError, error, fetchNextPage, hasNextPage, isFetchingNextPage,isLoading } = useInfiniteQuery(
        [`products`, name],
        ({ pageParam = page }) => fetchProducts(pageParam, name),
        {
            getNextPageParam: (lastPage, pages) => {
                return lastPage.length === 12 ? pages.length + 1 : undefined;
            },
            retry: 3
        }
    );

    const products = data?.pages.flat() || [];

    return {
        products,
        error: isError ? error.message : null,
        hasMore: hasNextPage,
        loadMore: fetchNextPage,
        isFetchingNextPage,
        isLoadInitially:isLoading
    };
}

